/**
 * @generated SignedSource<<0971c66179558d164d511c7d885219c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaultAvatar_vault$data = {
  readonly id: string;
  readonly members: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member">;
  }>;
  readonly name: string;
  readonly thumbnail: {
    readonly url: URIString;
  } | null;
  readonly " $fragmentType": "VaultAvatar_vault";
};
export type VaultAvatar_vault$key = {
  readonly " $data"?: VaultAvatar_vault$data;
  readonly " $fragmentSpreads": FragmentRefs<"VaultAvatar_vault">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VaultAvatar_vault",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "members",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatar_member"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Thumbnail",
      "kind": "LinkedField",
      "name": "thumbnail",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Vault",
  "abstractKey": null
};
})();

(node as any).hash = "a1873216e67a7d7e95509ad7af247f05";

export default node;
